export default "__VITE_ASSET__fc367285__"